'use client';

import { Provider as JotaiProvider } from 'jotai';

import { PosthogMeasurement } from '@/shared-measurement';
import {
  apiHost,
  posthogApiHost,
  posthogToken,
  SharedSurveyPosthogPageview,
} from '@/shared-survey';
import { ReportProblemProvider } from '@/shared-ui';
import { ApolloProvider } from '@/survey-graphql';
import { Toaster } from '@/ui';

interface Props {
  children: React.ReactNode;
}

export default function Providers({ children }: Props) {
  return (
    <JotaiProvider>
      <ApolloProvider apiHost={apiHost}>
        <PosthogMeasurement token={posthogToken} apiHost={posthogApiHost}>
          <SharedSurveyPosthogPageview />
          <Toaster>
            <ReportProblemProvider>{children}</ReportProblemProvider>
          </Toaster>
        </PosthogMeasurement>
      </ApolloProvider>
    </JotaiProvider>
  );
}
